<a *ngIf="ANDROID_APP" [href]="ANDROID_APP" download="" target="_blank" class="btn-google-play">
  <img src="{{sharedService.imagesUrl}}play-store-badge.png" />
</a>